import { render } from "./MarketingApp.vue?vue&type=template&id=47720fd2&scoped=true"
import script from "./MarketingApp.vue?vue&type=script&lang=js"
export * from "./MarketingApp.vue?vue&type=script&lang=js"

import "./MarketingApp.vue?vue&type=style&index=0&id=47720fd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47720fd2"]])

export default __exports__